module.exports = "/images/tag_2df882.png";